import { useField } from '@unform/core'
import { FunctionComponent, useRef, useState, useEffect } from 'react'
import { Subtitle1 } from 'stories/elements/Typography/Text'
import { FormGroup, ErrorMessage } from './Input.css'
import { InputProps, InputPropTypes } from './InputTypes'
import SelectArrowIcon from 'assets/icons/select-arrow.svg'
import styled from 'styled-components'

const SelectArrow = styled(SelectArrowIcon)`
    position: absolute;
    right: 10px;
    top: 45%;
`

interface SelectOption {
    label: string
    // eslint-disable-next-line
    data: any
}

const Select: FunctionComponent<InputProps> = (props) => {
    const { name, options, ...rest } = props
    const selectRef = useRef<HTMLSelectElement>(null)
    const { fieldName, defaultValue, registerField, error } = useField(name)
    const [selectedValue, setSelectedValue] = useState<SelectOption>()
    const isError = !!error

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: selectRef.current,
            path: undefined,
            getValue: (ref: HTMLSelectElement) => {
                if (options && options[parseInt(ref.value)]) {
                    return options[parseInt(ref.value)].data
                }
                return null
            },
            setValue: (ref: HTMLSelectElement, value: SelectOption) => {
                setSelectedValue(value)
            },
        })
    }, [fieldName, registerField, options])

    useEffect(() => {
        if (defaultValue) {
            setSelectedValue(defaultValue)
        }
    }, [defaultValue])

    useEffect(() => {
        const selectedIndex = options?.findIndex((option) => option.label === selectedValue?.label)
        if (selectedIndex !== undefined && selectedIndex !== -1 && selectRef.current)
            selectRef.current.value = selectedIndex.toString()
    }, [options, selectedValue?.data, selectedValue?.label])

    const onInput = (event: React.FormEvent<HTMLSelectElement>) => {
        if (!options) return
        // eslint-disable-next-line
        const selectedOption = options[parseInt((event.target as any).value)]
        if (props.onUpdate) {
            props.onUpdate(selectedOption.data)
        }
    }

    return (
        <FormGroup noMargin={!!props.noMargin} darkTheme={!!props.darkTheme} isError={isError}>
            <label>
                <Subtitle1>{props.label ?? props.placeholder}</Subtitle1>
            </label>
            <div className="select-wrapper">
                <SelectArrow />

                <select ref={selectRef} defaultValue={defaultValue} onInput={onInput} {...rest}>
                    <option>{props.label ?? props.placeholder}</option>
                    {options!.map((option, index) => (
                        <option value={index} key={index}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
            <ErrorMessage>{error}</ErrorMessage>
        </FormGroup>
    )
}

Select.propTypes = InputPropTypes

export default Select
